// Import all of Bootstrap's JS
import * as bootstrap from "bootstrap";

(function ($, Drupal) {
  "use strict";

  /**
   * Behavior description.
   */
  Drupal.behaviors.ghm = {
    attach: function (context, settings) {
      console.log("It works!");
      // const ex = new EX({ offset: 200 }).init();
    },
  };

  $(document).ready(function () {
    const ex = new EX({ offset: 200 }).init();
    $(".colorado-header .navbar-toggler").click(function () {
      $(".colorado-header").toggleClass("open");
    });

    $(".colorado-header").hover(function () {
      $(this).toggleClass("hover");
    });

    $(".colorado-header ul li.dropdown .dropdown-menu li a").click(function () {
        $(".colorado-header").removeClass("open");
    });

    $(window).on("resize", function () {
      const win = $(this); //this = window
      if (win.width() <= 990) {
        $(".colorado-header").removeClass("hover");
        $(".colorado-header").removeClass("open");
      }
    });

    // Define the list of classes to check
    var classesToCheck = ["black", "red", "light-green", "cream"];
    // Select the div to check
    var divToCheck = $(".node--type-ghm-type .hc-title-wrap:first-child");

    // Find the matching class
    var matchingClass = $.grep(classesToCheck, function (className) {
      return divToCheck.hasClass(className);
    })[0];

    // If a matching class is found, assign it to another div
    if (matchingClass) {
      $(".utility-nav").addClass(matchingClass);
    }

    //Added aria-label for social links
    $('a[href="http://www.facebook.com/granthumphreysmansion"]').attr('aria-label', 'Visit Granth Humphreys Mansion Facebook page');
    $('a[href="https://www.instagram.com/granthumphreysmansion/?hl=en"]').attr('aria-label', 'Visit Granth Humphreys Mansion Instagram page');
    $('a[href="https://www.linkedin.com/company/4799569/"]').attr('aria-label', 'Visit Granth Humphreys Mansion LinkedIn page');

    $('.contact-section-wrap h3').each(function () {
      // Check if the content is empty or contains only whitespace
      if ($(this).text().trim() === '') {
          $(this).html('<span class="visually-hidden">Placeholder text</span>');
      }
    })


    // Carousel for the homepage
    $(".connect-slider").slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: false,
      nextArrow: false,
      autoplay: true,
      autoplaySpeed: 3000,
      infinite: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });

    // Carousel for the panel members slider
    $(".panel-members-slider").slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: false,
      nextArrow: false,
      autoplay: true,
      autoplaySpeed: 3000,
      infinite: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });
  });
  // Init animation library
  // new EX({
  //   watchClass: "ex-watch", // applies all js triggers on this class
  //   animateClass: "ex-animate", // css class which is added to start animation
  //   offset: 120, // distance to the element when triggering the animation
  //   mobile: true, // trigger animations on mobile devices
  //   live: true, // act on asynchronously loaded content
  //   callback: function (box) {
  //     // the callback is fired every time an animation is started
  //     // the argument that is passed in is the DOM node being animated
  //     // console.log(box);
  //   },
  //   scrollContainer: null, // optional scroll container selector, otherwise use window,
  //   resetAnimation: true, // reset animation on end
  // }).init();
})(jQuery, Drupal);
